module.exports = __webpack_public_path__ + "static/bio-about-bg-a113eba6453d0f7439c3582148db3c41.png";